module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-header01.bed690d1.jpg";